<template>
  <q-scroll-area style="height: calc(100% - 150px); margin-top: 150px; border-right: 1px solid #ddd">
    <q-list padding separator dense>

      <q-item
        clickable
        v-ripple
        to="/presidencia"
        dense
      >
        <q-item-section avatar>
          <q-icon name="edit_note" />
        </q-item-section>

        <q-item-section>
          <strong>Solicitudes</strong>
        </q-item-section>
      </q-item>

      <q-expansion-item
        icon="insights"
        label="Reportes"
        default-opened
        class="text-weight-bold"
        expand-icon-class="text-white"
      >
        <q-list separator dense>
          <q-item
            clickable
            v-ripple
            :inset-level="1"
            to="/reportes/tipos-compra"
          >
            <q-item-section class="text-weight-regular">
              Tipos de compra
            </q-item-section>
          </q-item>
        </q-list>

      </q-expansion-item>

      <q-item
        clickable
        v-ripple
        to="/settings"
      >
        <q-item-section avatar>
          <q-icon name="settings" />
        </q-item-section>

        <q-item-section>
          <strong>Configuración</strong>
        </q-item-section>

      </q-item>

      <q-item
        clickable
        v-ripple
        @click="logout()"
      >
        <q-item-section avatar>
          <q-icon name="logout" />
        </q-item-section>

        <q-item-section>
          <strong>Cerrar sesión</strong>
        </q-item-section>

        <q-item-section avatar>
          <q-spinner-bars
            color="white"
            size="2em"
            v-if="loading"
          />
        </q-item-section>

      </q-item>

      <q-item
        v-ripple
      >
        <q-item-section>
          <strong>v{{util.getVersion()}}</strong>
        </q-item-section>
      </q-item>

    </q-list>
  </q-scroll-area>

  <q-img class="absolute-top" src="https://cdn.quasar.dev/img/material.png" style="height: 150px">
    <div class="absolute-bottom bg-transparent-2" style="width: 100%; height: 100%">
      <div class="text-weight-bold q-pt-xl">{{user.nombre}}</div>
      <div>{{user.usuario}}</div>
    </div>
  </q-img>
</template>

<script>
import env from '../../config/env'
import {ref} from 'vue'
import { useQuasar } from 'quasar'
// import axios from 'axios'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import util from '../plugins/util'

export default {
  setup () {
    // Variables reactivas y no reactivas
    const $q = useQuasar()
    const router = useRouter()
    const store = useStore()

    const url = ref(env.SERVER_URL)
    const loading = ref(false)
    const empresa = $q.localStorage.getItem('empresa')
    const gestion = $q.localStorage.getItem('gestion')
    const gestiones = ref([])
    const user = ref(store.state.auth.user)

    // Métodos y funciones
    /* const getGestiones = async () => {
      let res = await axios.get('gestion')
      gestiones.value = res.data
    } */

    const logout = async () => {
      loading.value = true
      await store.dispatch('auth/logout')
      loading.value = false
      router.push({ name: 'login' })
    }

    // Creación del componente
    

    // Retorno de variables al template
    return {
      url,
      empresa,
      gestion,
      gestiones,
      logout,
      user,
      loading,
      util
    }
  }
}
</script>

<style>

</style>